import React from 'react';
import { Modal } from 'antd';
import useApi from '../../hooks/useApi';
import useUserType from '../../hooks/useUserType';

const ModalDelete = ({ visible, id, onCancel, onSuccess }) => {
  const userType = useUserType();
  const { callApi: deleteDepartamento } = useApi(`https://vision.alfama.com/api/delete/usuarios/${id}`, {
    method: 'DELETE',
    includeToken: true,
    successMessage: 'Usuário excluído com sucesso!',
    errorMessage: 'Erro ao excluir Usuário'
  });

  if (id === 1) {
    return (
      <Modal
        title={
          <div className="flex items-center gap-2 text-red-500">
            Aviso
          </div>
        }
        open={visible}
        onCancel={onCancel}
        footer={null}
      >
        <p>O administrador principal não pode ser excluído do sistema.</p>
      </Modal>
    );
  }

  const handleConfirm = async () => {
    try {
      await deleteDepartamento();
      onCancel();
      onSuccess();
    } catch (error) {
      console.error('Erro ao excluir Usuário:', error);
    }
  };

  return (
    <Modal
      title={
        <div className="flex items-center gap-2 text-red-500">
          Confirmação de Exclusão
        </div>
      }
      open={visible}
      onCancel={onCancel}
      onOk={handleConfirm}
      okText={userType === 'gerenciador' ? "Confirmar" : "Não possui acesso"}
      cancelText="Cancelar"
      okButtonProps={{ 
        danger: true,
        className: 'bg-red-500',
        disabled: userType !== 'administrador'
      }}
    >
      <p>Tem certeza que deseja excluir o ID: <strong>{id}</strong>?</p>
      <p>Esta ação não poderá ser desfeita.</p>
    </Modal>
  );
};

export default ModalDelete;